import { useCallback, useEffect, useRef, useState } from 'react';

export function useSizePriceTicker() {
  const [isVisible, setIsVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const tickerRef = useRef<HTMLDivElement>(null);

  const show = useCallback(() => {
    setIsVisible(true);
    requestAnimationFrame(() => {
      setIsActive(true);
    });
  }, []);

  const hide = useCallback(() => {
    setIsActive(false);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const handleScroll = () => {
      hide();
    };

    const handleClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (tickerRef.current && !tickerRef.current.contains(target)) {
        hide();
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    document.body.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.removeEventListener('click', handleClick);
    };
  }, [hide, isVisible]);

  return {
    isVisible,
    isActive,
    show,
    hide,
    tickerRef,
  };
}
